<template lang="pug">
  yz-dialog(v-model="showDialog" scrollable, max-width="500px" persistent)
    yz-card
      yz-dialog-normal-header(:title="`Delete invoice from bulk claim`" @close="onCloseDialog" :disable-close="isDeleting")

      yz-dialog-normal-content.pa-6
          .d-flex.align-start
            // Alert icon
            yz-icon.mr-2.mt-1(size="20px" color="danger") $yzi-alert-circle

            // Primary message
            .yz-medium-body-md.text-neutral-700 This action will remove invoice from this bulk claim.

          // Explanatory text
          .yz-regular-body-sm.text-neutral-700.mt-2 The selected invoice will be unlinked from the bulk claim. Invoice will still be available in Checkout.

          // Action instruction
          .yz-regular-body-sm.text-neutral-700.mt-2 Click 'Confirm' to continue.

      yz-dialog-normal-actions
        yz-btn(label="Cancel" text size="lg" @click="onCancelDelete" :disabled="isDeleting")
        yz-btn(label="Confirm" color="danger" size="lg" @click="onConfirmDelete" :loading="isDeleting")
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  props: {
    value: {
      type: Boolean,
      default: false
    },
    parentUid: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      isDeleting: false
    }
  },
  computed: {
    ...mapGetters({
      company: 'getCompany'
    }),
    showDialog: {
      get() {
        return this.value
      },
      set(newValue) {
        this.$emit('input', newValue)
      }
    }
  },
  methods: {
    ...mapActions(['showMessage']),
    onCloseDialog() {
      this.$emit('input', false)
      this.$emit('canceled')
    },
    onCancelDelete() {
      this.onCloseDialog()
    },
    async onConfirmDelete() {
      this.isDeleting = true
      try {
        await this.$axios.patch(`/panels/${this.company.slug}/invoices/${this.parentUid}`, {
          panel_claim: null
        })
        await this.showMessage(['success', 'Invoice removed from bulk claim successfully'])
        this.$emit('confirmed')
        this.$emit('input', false)
      } catch (error) {
        console.error('Error deleting invoice from bulk claim:', error)
        await this.showMessage(['error', error.response?.data?.message || 'Failed to delete invoice from bulk claim'])
      } finally {
        this.isDeleting = false
      }
    }
  }
}
</script>